import { render, staticRenderFns } from "./custom-picture.vue?vue&type=template&id=cc70901e"
import script from "./custom-picture.vue?vue&type=script&lang=js"
export * from "./custom-picture.vue?vue&type=script&lang=js"
import style0 from "./custom-picture.vue?vue&type=style&index=0&id=cc70901e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc70901e')) {
      api.createRecord('cc70901e', component.options)
    } else {
      api.reload('cc70901e', component.options)
    }
    module.hot.accept("./custom-picture.vue?vue&type=template&id=cc70901e", function () {
      api.rerender('cc70901e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/components/custom-picture.vue"
export default component.exports